import WeekSelector from "./WeekSelector";
import WeekView from "./WeekView";
import TimeCodeSelector from "./TimeCodeSelector";
import {AddNewTimecode, UpdateTimesheetLocalState} from '../../services/TimesheetDataService';
import './Timesheet.css'
import MobileDayTotals from "./MobileDayTotals";
import MonthlyReview from "./MonthlyReview";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import ExportToCSV from '../ExportToCSV';
import DateFormatToggle from './DateFormatToggle'
import UserSelector from "../admin/UserSelector";

export default function Timesheet(props) {   
  const{isDesktop, lockedMonths}= useGlobalStatus();
   
  const handleTimecodeAdd = (currentWeekStart, client, project, budget, timecode, userDetails, existingTimecode)=> {      
    var updated = AddNewTimecode(currentWeekStart, [...props.timesheetData], client, project, budget, timecode, userDetails, existingTimecode, lockedMonths);
    props.setTimesheetData(updated);  
  }

  const handleEntryCellAction=(data, day)=>{
    var updated = UpdateTimesheetLocalState(props.timesheetData, data, day);
    props.setTimesheetData(updated);  
  }

  const handleWeekChange=(currentWeekStart, client, project, budget, timecode, userDetails, existingTimecode)=> {      
    var updated = AddNewTimecode(currentWeekStart, [...props.timesheetData], client, project, budget, timecode, userDetails, existingTimecode);
    props.setTimesheetData(updated);  
    
  }
  
  return (
    <>
        <WeekSelector setTimesheetData={props.setTimesheetData} setPrevWeekTimesheetData={props.setPrevWeekTimesheetData} leaveData={props.leaveData} setLeaveData={props.setLeaveData} handleWeekChange={handleWeekChange} handleTimecodeAdd={handleTimecodeAdd} timesheetData={props.timesheetData} prevWeekTimesheetData={props.prevWeekTimesheetData} timesheetStatusMessage={props.timesheetStatusMessage} setTimesheetStatusMessage={props.setTimesheetStatusMessage} setCalendarData={props.setCalendarData} calendarData={props.calendarData} />
        <div className="approver-section">
          <div style={{
              marginBottom: '-0.5rem'
            }}>
            <TimeCodeSelector handleTimecodeAdd={handleTimecodeAdd} existingData={props.timesheetData}/>
            <MonthlyReview timesheetData={props.timesheetData}></MonthlyReview>
          </div>
          

          <WeekView setTimesheetData={props.setTimesheetData} setPrevWeekTimesheetData={props.setPrevWeekTimesheetData} timesheetData={props.timesheetData} prevWeekTimesheetData={props.prevWeekTimesheetData} leaveData={props.leaveData} handleEntryCellAction={handleEntryCellAction} setCalendarData={props.setCalendarData} calendarData={props.calendarData} />    
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              marginTop: '1rem'
            }}
          >
          {!isDesktop && props.leaveData && <MobileDayTotals timesheetData={props.timesheetData} leaveData={props.leaveData}/>}
          <ExportToCSV email="" type="month" text="Export Month as CSV"></ExportToCSV>
          <DateFormatToggle></DateFormatToggle>
          {props.isAdmin && <UserSelector />}
          </div>
          
        </div>     
      </>
  );
}